import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditHumanNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditHumanNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditHumanNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }

    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        question: {
            title: 'What to ask the human',
            type: 'string',
            description: 'Enter a question to ask the human or use variables to use Data Slots or LLM messages'
        },
        conditional_exit: {
            title: 'Conditional Exit',
            type: 'boolean',
            description: 'If true, sending a response back to the LLM of "continue" or "fail" will route the workflow to the respective handles. If false, the single exit node handle is used',
            default: false
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        }
    },
}

export const nodeDescription: string = "This node is used to ask a human for input. \n";

